export default __webpack_public_path__ + "static/media/Snare3.3150f0ce.mp3";